import { getServerRequest } from '../../helpers/serverRequest';
import { store } from '../../store/store';

const httpURL = store.getters.httpURL;

export async function getSession(token) {
    const config = { headers: { token } };
    const url = `${httpURL}/login/session`;
    return await getServerRequest(url, config);
}